import type { ImageData } from './../../ricos-schema/next-schema';

const WIX_STATIC_URL = 'https://static.wixstatic.com/media';

export const getImageUrl = (imageData: ImageData): string => {
  return imageData.image?.src?.url ?? `${WIX_STATIC_URL}/${imageData.image?.src?.id}`;
};
